import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as actions from "../../store/referenceLabs/actions";
import TableGridView from "../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import { withStyles } from "@material-ui/styles";
import Switch from '@material-ui/core/Switch';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';

const MySwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: "#FFF",
      '& + $track': {
        backgroundColor: '#24D7D3',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#24D7D3',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 22,
    height: 22,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const ReferenceLabs = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const { referenceLabs } = useSelector((state) => state.referenceLabs);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [blockConfirmation, setBlockConfirmation] = useState(false);
  const [selectedRef, setSelectedRef] = useState({});

  useEffect(() => {
    //Get internal Users list
    dispatch(
      actions?.getReferenceLabsRequest({
        page: 1,
        sort: "is_active,desc",
      })
    );
    return () => {
      dispatch(actions.getReferenceLabsReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //table n grid view render
  const headings = [
    messages.referenceLabs.ref_id,
    messages.referenceLabs.arabic_name,
    messages.referenceLabs.english_name,
    messages.referenceLabs.country,
    messages.referenceLabs.city,
    messages.referenceLabs.status,
    messages.referenceLabs.actions,
  ];

  const renderTableData = () => {
    return referenceLabs?.data?.map((reference, i) => {
      const {
        code,
        name,
        country_name,
        city_name,
        is_active,
      } = reference;
      return [
        code,
        <Tooltip title={name?.ar} placement="bottom" onClick={(e) => history.push(`/reference-labs/edit/${reference.id}`)} style={{ cursor: "pointer" }}>
          <span className="arabic_name">
            {name?.ar?.length > 25 ? `${name?.ar.substring(0,25)}...` : name?.ar}
          </span>
        </Tooltip>,
        <Tooltip title={name?.en} placement="bottom" onClick={(e) => history.push(`/reference-labs/edit/${reference.id}`)} style={{ cursor: "pointer" }}>
          <span className="english_name">
            {name?.en?.length > 25 ? `${name?.en.substring(0,25)}...` : name?.en}
          </span>
        </Tooltip>,
        country_name,
        city_name,
        <MySwitch checked={is_active === 1} name="block" onChange={() => {
          if (is_active === 1) {
            setSelectedRef(reference);
            setBlockConfirmation(true);
          } else {
            dispatch(actions.activeReferenceLabRequest(reference.id));
          }
        }} />,
        <div className="actions-icons">
          <EditRoundedIcon onClick={() => history.push(`/reference-labs/edit/${reference.id}`)} />
          <DeleteForeverRoundedIcon onClick={() => {
            setSelectedRef(reference);
            setDeleteConfirmation(true);
          }}/>
        </div>,
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getReferenceLabsRequest({
        page,
        sort: "is_active,desc",
        ...searchValues,
      })
    );
  };

  return (
    <>
      {referenceLabs ? (
        <div style={{ padding: '5px 0'}}>
          <button className={`myBtn ${lang === 'ar' && 'rtl'}`} 
              onClick={(e) => {e.preventDefault(); history.push("/reference-labs/add")}} >
              <AddCircleOutlineOutlinedIcon />{messages.referenceLabs.add_new}
          </button>
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: referenceLabs?.data?.length,
                    totals: referenceLabs?.total,
                  }}
                  id="referenceLabs.refs_of"
                  defaultMessage={messages.referenceLabs.refs_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            //gridView={renderGridView}
            pagination={{
              count: referenceLabs.last_page,
              page: referenceLabs.current_page,
              handleChange: handlePageChange,
            }}
          />
        </div>
      ) : null}

      <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => {
                        setDeleteConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.deleteReferenceLabRequest(selectedRef.id))
                        setDeleteConfirmation(false);
                     }}
                     content={messages.programs.delete_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
      
      <ConfirmDialog show={blockConfirmation} 
                     onCancel={() => {
                        setBlockConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.desactiveReferenceLabRequest(selectedRef.id))
                        setBlockConfirmation(false);
                     }}
                     content={messages.referenceLabs.desactive_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
    </>
  );
};

export default injectIntl(ReferenceLabs);
